import { render, staticRenderFns } from "./enterpriseHlrjFooter.vue?vue&type=template&id=f80bf40a&scoped=true&"
import script from "./enterpriseHlrjFooter.vue?vue&type=script&lang=js&"
export * from "./enterpriseHlrjFooter.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseHlrjFooter.vue?vue&type=style&index=0&id=f80bf40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80bf40a",
  null
  
)

export default component.exports